import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';

// DEV-ONLY: install the mock data layer before the first render so the app
// renders the full design on localhost without a backend. Wrapped in an async
// bootstrap (not a top-level await) so the production build target is happy,
// while still guaranteeing mocks are installed before any API call fires.
async function bootstrap() {
  if (import.meta.env.VITE_USE_MOCKS === '1') {
    const { installMocks } = await import('@/mocks');
    installMocks();
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

void bootstrap();
